module.exports = __webpack_public_path__ + "/7086976f8baccb5e32a34f379b00b9d5.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/docusign-switch/assets/logos/openlegal_logo.png
 ** module id = 957
 ** module chunks = 0
 **/